import { getStateLabel } from "../utils/thorState";

const STATE_COLORS = {
    design: 'is-info is-light',
    design_review: 'is-warning is-light',
    instrumentation: 'is-warning',
    pre_prod_validation: 'is-link is-light',
    running: 'is-success',
    paused: 'is-warning',
    cancelled: 'is-danger is-light',
    ended: 'is-dark',
    cleanup: 'is-dark is-light',
    finished: 'is-success is-light',
};

const STATE_DESCRIPTIONS = {
    design: 'Experiment is being designed. Fill in Hypothesis, Buckets, Metrics, and Audiences before requesting a Design Review.',
    design_review: 'Waiting for Analyst Design Review and Engineer Design Review approvals.',
    instrumentation: 'Engineer is instrumenting the experiment in code and must submit an Instrumentation Signoff.',
    pre_prod_validation: 'Experiment is ready for final validation. The owner must submit a Pre-prod Signoff before going live.',
    running: 'Experiment is live and bucketing real users in production.',
    paused: 'Experiment is temporarily paused. Resume from Run Experiment or transition to Test Ending.',
    cancelled: 'Experiment was cancelled and will not proceed further.',
    ended: 'Experiment has ended. Fill in the Outcome before moving to Clean Up.',
    cleanup: 'Experiment is being cleaned up from code. Engineer must submit a Cleanup Signoff.',
    finished: 'Experiment is fully complete and cleaned up.',
};

const StateChip = ({ state, className = '' }) => (
    <span
        className={`tag ${STATE_COLORS[state] ?? 'is-light'} ${className}`}
        title={STATE_DESCRIPTIONS[state]}
        style={{ cursor: 'help' }}
    >
        {getStateLabel(state)}
    </span>
);

export default StateChip;
